import React, { useState, useRef } from 'react';
import { Popconfirm, Input, Space } from 'antd';
import Button from '@iso/components/uielements/button';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useRouteMatch } from 'react-router-dom';
import Highlighter from 'react-highlight-words';
import notification from '@iso/components/Notification';
import HelperText from '@iso/components/utility/helper-text';
import LayoutWrapper from '@iso/components/utility/layoutWrapper';
import PageTitleBar from '@iso/components/utility/PageTitleBar';
import PageTitleActions from '@iso/containers/Dashboard/PageTitleActions';
import FormWindow from '@iso/containers/Dashboard/FormWindow';
import EditBrand from './EditBrand';
import Scrollbars from '@iso/components/utility/customScrollBar';
import brandActions from '@iso/redux/brand/actions';
import CardWrapper, { Box, StatusTag } from './Brand.style';
import TableWrapper from '../../Tables/AntTables/AntTables.styles';
import { b64_to_utf8 } from '@iso/lib/helpers/utility';
import { SearchOutlined, PlusOutlined } from '@ant-design/icons';
import Loader from '@iso/components/utility/loader';

const { initData, deleteBrand } = brandActions;

export default function Brand() {
	const ses = sessionStorage.getItem("permissions");
	const arraySplit = b64_to_utf8(ses).split(",");
  const [selected, setSelected] = useState([]);
  // Janela flutuante de cadastro/edição (FormWindow padrão)
  const [editingId, setEditingId] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const { initialBrand, brands } = useSelector((state) => state.Brand);
  const dispatch = useDispatch();
  const match = useRouteMatch();
  const searchInput = useRef(null);

  React.useEffect(() => {
    if (!initialBrand) {
      dispatch(initData());
    }
  }, [dispatch, initialBrand]);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = (dataIndex, collum) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`Buscar ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, collum)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, collum)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Buscar
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Limpar
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            Fechar
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        title={"Pesquisar pelo "+dataIndex+" da Marca"}
        style={{
          color: '#000000',
        }}
      />
    ),
    onFilter: (value, record) =>
      record[collum].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === collum ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const columns = [
    {
      title: 'Nome',
      dataIndex: 'name',
      key: 'name',
      width: '75%',
      render: (text) => <span>{text}</span>,
      ...getColumnSearchProps('Nome', 'name')
    },
    {
      title: 'Status',
      dataIndex: 'situation',
      key: 'situation',
      width: '25%',
      render: (text, situation) => {
        let className;
        if (text === 'ativo' || text === 'Ativo' || text === 'ATIVO') {
          className = 'ativo';
        } else if ( text === 'inativo' || text === 'Inativo' || text === 'INATIVO' ) {
          className = 'inativo';
        }
        return <StatusTag className={className}>{text}</StatusTag>;
      },
    },
    {
      title: '',
      dataIndex: 'view',
      key: 'view',
      width: '10%',
      render: (_, brand) =>{
        return (
          <div className="isoBrandBtnView">
            {arraySplit.includes('Marca_editar') || arraySplit.includes('all')  ? 
              <a
                href={match.path + '/' + brand._id}
                onClick={(event) => {
                  event.preventDefault();
                  setEditingId(brand._id);
                }}
              >
                <Button color="primary" className="brandViewBtn">
                  Editar
                </Button>
              </a>
            : ''}
            {arraySplit.includes('Marca_excluir') || arraySplit.includes('all')  ? 
              <Popconfirm title="Deseja realmente deletar?" onConfirm={() => {
                const index = brands.map(inv => inv._id).indexOf(brand._id);
                dispatch(deleteBrand(brands[index]._id));
                notification('success', '1 Marca deletado');
              }}>
                <Button className="brandDltBtn" onClick={() => { }}>
                  <i className="ion-android-delete" />
                </Button>
              </Popconfirm>
            : ''}
          </div>
        )
      }
    },
  ];

  const rowSelection = {
    hideDefaultSelections: true,
    selectedRowKeys: selected,
    onChange: (selected) => setSelected(selected),
    selections: [
      {
        rowKey: 'all-data',
        text: 'Selecionar todos',
        onSelect: () => setSelected(brands.map((brand) => brand._id)),
      },
      {
        rowKey: 'no-data',
        text: 'Desselecionar',
        onSelect: () => setSelected([]),
      },
    ],
    onSelection: (selected) => setSelected(selected),
  };

  return (
    <LayoutWrapper>
      
      <PageTitleBar title="Marcas" />
      <PageTitleActions
        primary={{
          key: 'create',
          label: 'Adicionar',
          onClick: () => setEditingId('0'),
        }}
      />
      <Box style={{ border: 'none', boxShadow: 'none' }}>
        {!initialBrand ? (
          <Loader />
        ) : (
        <CardWrapper>
          {brands !== undefined && brands.length === 0 ? (
            <HelperText text="Sem Marca" />
          ) : (
            <div className="isoBrandTable">
              <div
                style={{ width: '100%' }}
              >
                <TableWrapper
                  rowKey={"_id"}
                  rowSelection={rowSelection}
                  dataSource={brands}
                  columns={columns}
                  pagination={{ defaultPageSize: 20, showSizeChanger: true, pageSizeOptions: ['10', '20', '50', '100'] }}
                  className="brandListTable"
                />
              </div>
            </div>
          )}
        </CardWrapper>
        )}
      </Box>

      {/* JANELA FLUTUANTE padrão (FormWindow) */}
      <FormWindow
        open={editingId !== null}
        title={editingId === '0' ? 'Cadastro de Marca' : 'Edição de Marca'}
        onClose={() => setEditingId(null)}
      >
        {({ footerEl }) =>
          editingId !== null ? (
            <EditBrand
              brandId={editingId}
              inModal
              footerEl={footerEl}
              onCancel={() => setEditingId(null)}
              onSaved={() => {
                setEditingId(null);
                dispatch(initData());
              }}
            />
          ) : null
        }
      </FormWindow>
    </LayoutWrapper>
  );
}